<template>
  <div class="admin-page">
    <br><br>
    <transition name="toast">
      <Toast v-if="toast" :msg="msg" />
    </transition>
    <ul class="menu-bar">
      <li
        class="menu-icon"
        @click="toggleAdmin"
      >
        <PlusIcon style="width: 25px;" />
        <p>Add</p>
      </li>
      <li
        class="menu-icon"
        @click="toggleRecords"
      >
        <ViewListIcon style="width: 25px;" />
        <p>Register</p>
      </li>
      <li
        class="menu-icon"
        @click="toggleMakeAnnouncement"
      >
        <DocumentAddIcon style="width: 25px;" />
        <p>Notice</p>
      </li>
      <li
        class="menu-icon"
        @click="toggleUploadAssignment"
      >
        <BookOpenIcon style="width: 25px;" />
        <p>Homework</p>
      </li>
    </ul>
    <br>
    <div v-if="showMakeAdmin">
      <AddLearnerRecord
      @newClassAnnouncementCreated="triggerToast"
      :classTeacher="currentUser"
      />
    </div>
    <div v-if="showRecords">
      <ClassRegister
      @toasts="checkToast"
      :classLearners="currentUser.state.grade" />
      <ClassLearnersRecords
      :classTeacher="currentUser"
      @toasts="deletedToast"
      :key="rendKey"
      />
    </div>
    <div v-if="showUploadAssignment"
      class="admin-card card"
    >
      <file-upload
        :uploader="currentUser.state"
        @fileuploaded="toggleMakeAnnouncement" />
      <h3>Uploaded Class Work</h3>
      <p>All the assignments and class work files that you have uploaded so far. Ensure to delete old assignments</p>
      <br>
      <class-uploads
      @announcementdeleted="toggleMakeAnnouncement"
      :uploader="currentUser.state"
      />
    </div>
    <div v-if="showMakeAnnouncement">
      <add-announcement
      @newClassAnnouncementCreated="toggleMakeAnnouncement"
      :classTeacher="currentUser"
      />
    </div>
    <div
      v-if="showWelcome"
      class="admin-card card"
    >
      <h3>Welcome Teacher</h3>
      <p>Manage your class from here. Plan your class work, give out homework, mark, grade and record learner performance all in one place</p>
      <br>
      <class-announcements
      @announcementdeleted="toggleMakeAnnouncement"
      :classNotice="currentUser.state"
      />
    </div>
  </div>
</template>

<script>
import AddLearnerRecord from '@/components/AddLearnerRecord.vue'
import AddAnnouncement from '@/components/AddAnnouncement.vue'
import ClassUploads from '@/components/ClassUploads.vue'
import FileUpload from '@/components/FileUpload.vue'
import ClassAnnouncements from '@/components/ClassAnnouncements.vue'
import ClassRegister from '@/components/ClassRegister.vue'
import ClassLearnersRecords from '@/components/ClassLearnersRecords.vue'
import Toast from '@/components/Toast'
import { DocumentAddIcon, ViewListIcon, PlusIcon, BookOpenIcon } from '@heroicons/vue/outline'
import { ref } from '@vue/reactivity'
import { inject } from 'vue'

export default {
  components: { AddLearnerRecord, ClassRegister, DocumentAddIcon, Toast, ViewListIcon, PlusIcon, BookOpenIcon, AddAnnouncement, ClassUploads, FileUpload, ClassLearnersRecords, ClassAnnouncements },
  setup () {
    const showMakeAdmin = ref(false)
    const showMakeAnnouncement = ref(false)
    const toast = ref(false)
    const showRecords = ref(false)
    const showWelcome = ref(true)
    const msg = ref('Record Added')
    const rendKey = ref(0)
    const showUploadAssignment = ref(false)
    const currentUser = inject('currentUser')

    const toggleAdmin = () => {
      // showMakeAdmin.value = !showMakeAdmin.value
      showRecords.value = false
      showMakeAnnouncement.value = false
      showUploadAssignment.value = false
      showWelcome.value = !showMakeAdmin.value
    }

    const toggleRecords = () => {
      showRecords.value = !showRecords.value
      showMakeAdmin.value = false
      showMakeAnnouncement.value = false
      showUploadAssignment.value = false
      showWelcome.value = !showRecords.value
    }

    const toggleMakeAnnouncement = () => {
      showMakeAnnouncement.value = !showMakeAnnouncement.value
      showMakeAdmin.value = false
      showRecords.value = false
      showUploadAssignment.value = false
      showWelcome.value = !showMakeAnnouncement.value
    }

    const toggleUploadAssignment = () => {
      showUploadAssignment.value = !showUploadAssignment.value
      showMakeAdmin.value = false
      showRecords.value = false
      showMakeAnnouncement.value = false
      showWelcome.value = !showUploadAssignment.value
    }

    const triggerToast = () => {
      toast.value = true
      setTimeout(() => {
        toast.value = false
      }, 3000)
    }

    const checkToast = ({ load, toasts }) => {
      msg.value = toasts
      triggerToast()
      if (load) { rendKey.value += 1 }
    }

    const deletedToast = (edit) => {
      msg.value = 'Deleted'
      if (edit) {
        msg.value = 'Perfomance Report Edited'
      }
      toast.value = true
      setTimeout(() => {
        toast.value = false
      }, 3000)
    }

    return { toggleAdmin, showMakeAdmin, toast, triggerToast, checkToast, rendKey, toggleRecords, showRecords, msg, deletedToast, toggleUploadAssignment, showMakeAnnouncement, toggleMakeAnnouncement, currentUser, showUploadAssignment, showWelcome }
  }
}
</script>

<style>
.menu-bar {
  display:-webkit-box;
  display:-moz-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  position: relative;
  font-weight: 400;
  user-select: none;

  margin: 0.1em 0;
  padding: 0.4em;
  border-radius: 0.25em;
  height: 1.5em;
/* background: hotpink; */
  color: white;
  list-style-type: none;
}
.menu-bar .menu-icon {
  display:-webkit-box;
  display:-moz-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  display: flex;
  border: orangered;
  position: relative;
}
.menu-bar .menu-icon p {
  padding: 5px 0 0 0;
}
.menu-bar .menu-icon a {
  display:-webkit-box;
  display:-moz-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  text-decoration: none;
  color: inherit;
  display: flex;
}
.admin-page {
  height: 100vh;
  max-width: 90vw;
  margin: auto;
}
.admin-card {
  color: white;
  max-width: 600px;
  margin: 0 auto;
  padding: 0.4em;
  border-radius: 0.25em;
  background: #bbb;
}
  /* enter transitions */
  .toast-enter-active {
    animation: wobble 0.5s ease;
  }
  /* leave transitions */
  .toast-leave-to {
    opacity: 0;
    transform: translateY(-60px);
  }
  .toast-leave-active {
    transition: all 0.3s ease;
  }

  @keyframes wobble {
    0% { transform: translateY(-100px); opacity: 0 }
    50% { transform: translateY(0px); opacity: 1 }
    60% { transform: translateX(8px); opacity: 1 }
    70% { transform: translateX(-8px); opacity: 1 }
    80% { transform: translateX(4px); opacity: 1 }
    90% { transform: translateX(-4px); opacity: 1 }
    100% { transform: translateX(0px); opacity: 1 }
  }
</style>
